var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.492,
    height: 30.874,
    viewBox: "0 0 30.492 30.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8724",
    "data-name": "\\uC0AC\\uAC01\\uD615 8724",
    width: 30.492,
    height: 30.874,
    fill: "#222"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7574",
    "data-name": "\\uADF8\\uB8F9 7574",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7573",
    "data-name": "\\uADF8\\uB8F9 7573",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12542",
    "data-name": "\\uD328\\uC2A4 12542",
    d: "M29.15,16.7,30.484,6.312a.646.646,0,0,0,.007-.078.8.8,0,0,0-.777-.83L8.24,4.688,6.7,1.015a.8.8,0,0,0-.662-.49L.89,0Q.847,0,.8,0a.806.806,0,0,0-.08,1.608l4.681.468,6.668,15.947L11,19.218c-.437.5-1.736,1.994-1.137,3.312.551,1.207,2.244,1.242,2.435,1.242l16.46,0a.8.8,0,0,0,0-1.608H12.3a2.091,2.091,0,0,1-.816-.173l-.223-.1.077-.232a3.434,3.434,0,0,1,.879-1.39L13.4,18.948l15.035-1.554a.8.8,0,0,0,.715-.7m-15.629.621-4.6-11,19.857.661-1.141,8.88Z",
    transform: "translate(0 0)",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12543",
    "data-name": "\\uD328\\uC2A4 12543",
    d: "M36.287,35.4a2.94,2.94,0,1,0,2.94,2.94,2.944,2.944,0,0,0-2.94-2.94m0,4.271a1.332,1.332,0,1,1,1.333-1.332,1.335,1.335,0,0,1-1.333,1.332",
    transform: "translate(-9.801 -10.403)",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12544",
    "data-name": "\\uD328\\uC2A4 12544",
    d: "M16.8,35.4h0a2.94,2.94,0,1,0,2.94,2.939A2.945,2.945,0,0,0,16.8,35.4m0,4.271h0a1.332,1.332,0,1,1,1.334-1.332A1.323,1.323,0,0,1,16.8,39.668",
    transform: "translate(-4.074 -10.403)",
    fill: "#222"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon_cart.eb8d3de27eac81c3db30052189ca0dcb.svg";
export { ForwardRef as ReactComponent };